<template>

    <div
        class="shop-single-item-container mt-5"
    >

        <div class="row">

            <div class="col-12 mb-5 pb-5">

                <p class="text-center mx-auto gold-like-title shop-like-header__gold-text justify-content-center pb-2 mb-4" v-html="$root.translateStringRecycling('table-title-2')"></p>

                <template v-for="(element, index) in nutritionals">

                    <div class="table-mobile d-flex flex-column w-100 mx-auto mb-5 d-xl-none px-2">

                        <div class="title-block p-3 bg-lightgold text-center bg-black mb-4">
                            <span class="h6 text-primary text-uppercase d-block fw-normal p-0 m-0">
                                <span class="text-black">{{ element.label[lang] }}</span>
                            </span>
                        </div>

                        <template v-if="index != 'valore_energetico'">

                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="simple-text text-secondary text-gold">85 g/ml</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="text-right">{{ nutritionalInformations.dichiarazione_nutrizionale[index][85] ?? 0 }} g</span>
                                </div>
                            </div>

                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="simple-text text-secondary text-gold">100 g/ml</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="text-right">{{ nutritionalInformations.dichiarazione_nutrizionale[index][100] ?? 0 }} g</span>
                                </div>
                            </div>

                        </template>

                        <template v-else>
                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="simple-text text-secondary text-gold">85 g/ml</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="text-right">
                                        E = {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][85]['Kj'] }} Kj / {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][85]['Kcal'] }} Kcal
                                    </span>
                                </div>
                            </div>

                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="simple-text text-secondary text-gold">100 g/ml</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="text-right">
                                        E = {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][100]['Kj'] }} Kj / {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][100]['Kcal'] }} Kcal
                                    </span>
                                </div>
                            </div>
                        </template>

                    </div>

                </template>

                <div class="position-relative w-100 px-2 table-mobile mx-auto pt-3 d-xl-none">
                    <div class="p-3 border d-flex align-items-center flex-column">
                        <span class="pb-2">
                            {{ grado_alcolico.label[lang] }}
                        </span>
                        <span class="text-grey">
                            {{ nutritionalInformations.dichiarazione_nutrizionale.grado_alcolico }} %VOL
                        </span>
                    </div>
                </div>

                <p class="text-center mx-auto gold-like-title shop-like-header__gold-text justify-content-center pt-2 mt-5 mb-2 d-xl-none" v-html="$root.translateStringRecycling('table-title-3')"></p>

                <div class="position-relative w-100 px-2 table-mobile mx-auto pt-3 d-xl-none">

                    <div class="p-4 border d-flex align-items-center flex-column mb-5">
                       <ul class="pl-0 w-100 mb-0">
                        <template v-for="(el, index) in nutritionalInformations.ingredienti">

                            <template v-if="el != null && Array.isArray(el)">

                                <li class="d-flex py-1">
                                    <span class="flex-shrink-0 text-gold pr-2 position-relative">
                                        <h3 style="line-height: 1;">&bull;</h3>
                                    </span>
                                    <span class="" style="padding-top: 1px;">
                                        {{ ingredients[index].label[lang] }}: {{ makeList(el) }}
                                    </span>
                                </li>

                            </template>

                            <li v-else-if="el != null && el.key" class="d-flex py-1">
                                <span class="flex-shrink-0 text-gold pr-2 position-relative">
                                    <h3 style="line-height: 1;">&bull;</h3>
                                </span>
                                <span class="text-capitalize" style="padding-top: 1px;">
                                    {{ ingredients[index].label[lang] }}
                                </span>
                            </li>

                        </template>

                       </ul>
                    </div>

                </div>

                <!-- DESKTOP -->

                <table class="table table-striped mx-auto d-none d-xl-table" style="max-width: 1000px">
                    <thead>
                        <tr>
                            <th scope="col" colspan="2" class="text-center py-4 px-4 border-0 bg-gold">
                                <span class="h6 text-primary d-block fw-normal p-0 m-0">
                                    <span class="text-white text-uppercase font-weight-light"></span>
                                </span>
                            </th>
                            <th scope="col" class="text-center py-4 px-4 border-0 bg-gold">
                                <span class="h6 text-primary d-block fw-normal p-0 m-0">
                                    <span class="text-white font-weight-light">85 g/ml</span>
                                </span>
                            </th>
                            <th scope="col" class="text-center py-4 px-4 border-0 bg-gold">
                                <span class="h6 text-primary d-block fw-normal p-0 m-0">
                                    <span class="text-white font-weight-light">100 g/ml</span>
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(element, index) in nutritionals">
                            <tr>
                                <td class="text-center" colspan="2">
                                    <span class="h6 text-primary d-block fw-normal">
                                        <span class="text-black">
                                            {{ element.label[lang] }}
                                        </span>
                                    </span>
                                </td>
                                <template v-if="index != 'valore_energetico'">
                                    <td class="text-center">
                                        <span class="text-secondary">
                                            {{ nutritionalInformations.dichiarazione_nutrizionale[index][85] ?? 0 }} g
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span class="text-secondary">
                                            {{ nutritionalInformations.dichiarazione_nutrizionale[index][100] ?? 0 }} g
                                        </span>
                                    </td>
                                </template>

                                <template v-else>
                                    <td class="text-center">
                                        <span class="text-secondary">
                                            E = {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][85]['Kj'] }} Kj / {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][85]['Kcal'] }} Kcal
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span class="text-secondary">
                                            E = {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][100]['Kj'] }} Kj / {{ nutritionalInformations.dichiarazione_nutrizionale['valore_energetico'][100]['Kcal'] }} Kcal
                                        </span>
                                    </td>
                                </template>

                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="position-relative w-100 px-2 mx-auto pt-3 mt-5 d-none d-xl-block" style="max-width: 1000px;">
                    <div class="px-5 py-4 border d-flex align-items-center justify-content-between">
                        <span class="py-2">
                            {{ grado_alcolico.label[lang] }}
                        </span>
                        <span class="text-grey py-2">
                            {{ nutritionalInformations.dichiarazione_nutrizionale.grado_alcolico }} %VOL
                        </span>
                    </div>
                </div>

                <p class="text-center mx-auto gold-like-title shop-like-header__gold-text justify-content-center pt-5 mt-5 mb-3 d-none d-xl-block" v-html="$root.translateStringRecycling('table-title-3')"></p>

                <div class="position-relative w-100 px-2 mx-auto pt-3 d-none d-xl-block" style="max-width: 1000px;">

                    <div class="p-4 border d-flex align-items-center flex-column mb-5">
                       <ul class="pl-0 w-100 mb-0 p-3">
                        <template v-for="(el, index) in nutritionalInformations.ingredienti">

                            <template v-if="el != null && Array.isArray(el)">

                                <li class="d-flex py-1">
                                    <span class="flex-shrink-0 text-gold pr-2 position-relative">
                                        <h3 style="line-height: 1;">&bull;</h3>
                                    </span>
                                    <span class="" style="padding-top: 3px;">
                                        {{ ingredients[index].label[lang] }}: {{ makeList(el) }}
                                    </span>
                                </li>

                            </template>

                            <li v-else-if="el != null && el.key" class="d-flex py-1">
                                <span class="flex-shrink-0 text-gold pr-2 position-relative">
                                    <h3 style="line-height: 1;">&bull;</h3>
                                </span>
                                <span class="text-capitalize" style="padding-top: 3px;">
                                    {{ ingredients[index].label[lang] }}
                                </span>
                            </li>

                        </template>

                       </ul>
                    </div>

                </div>

            </div>
        </div>

    </div>

</template>

<script>

    export default {
        props: ['lang', 'product', 'combinationId'],
        data() {
            return {
                nutritionals: {
                    valore_energetico: {
                        label: {
                            it: 'VALORE ENERGETICO',
                            en: 'ENERGY VALUE',
                            de: 'ENERGIEWERT'
                        },
                    },
                    grassi: {
                        label: {
                            it: 'GRASSI',
                            en: 'FATS',
                            de: 'FETTE'
                        },
                    },
                    grassi_saturi: {
                        label: {
                            it: 'di cui acidi grassi saturi',
                            en: 'of which saturated fats',
                            de: 'davon gesättigte Fettsäuren'
                        },
                    },
                    carboidrati: {
                        label: {
                            it: 'CARBOIDRATI',
                            en: 'CARBOHYDRATES',
                            de: 'KOHLENHYDRATE'
                        },
                    },
                    zuccheri: {
                        label: {
                            it: 'di cui zuccheri',
                            en: 'of which sugars',
                            de: 'davon Zucker'
                        },
                    },
                    proteine: {
                        label: {
                            it: 'PROTEINE',
                            en: 'PROTEINS',
                            de: 'PROTEINE'
                        },
                    },
                    sale: {
                        label: {
                            it: 'SALE',
                            en: 'SALT',
                            de: 'SALZ'
                        },
                    },
                    acidi_organici: {
                        label: {
                            it: 'ACIDI ORGANICI',
                            en: 'ORGANIC ACIDS',
                            de: 'ORGANISCHE SÄUREN'
                        },
                    },
                    polioli: {
                        label: {
                            it: 'POLIOLI (GLICERINA)',
                            en: 'POLYOLS (GLYCERINE)',
                            de: 'POLYOLE (GLYCERIN)'
                        },
                    },

                },
                grado_alcolico: {
                    label: {
                        it: 'GRADO ALCOLICO',
                        en: 'ALCOHOL LEVEL',
                        de: 'ALKOHOLISCHER INHALT'
                    },
                },
                ingredients: {
                    uva: {
                        label: {
                            it: 'Uve',
                            en: 'Grapes',
                            de: 'Trauben'
                        },
                    },
                    mosto: {
                        label: {
                            it: 'Mosto d’uve concentrato',
                            en: 'Concentrated grape must',
                            de: ''
                        },
                    },
                    mosto_rettificato: {
                        label: {
                            it: 'Mosto d’uve concentrato rettificato',
                            en: 'Rectified concentrated grape must',
                            de: 'Konzentrierter Traubenmost'
                        },
                    },
                    saccarosio: {
                        label: {
                            it: 'Saccarosio',
                            en: 'Sucrose',
                            de: 'Saccharose'
                        },
                    },
                    sciroppo_zuccherino: {
                        label: {
                            it: 'Sciroppo zuccherino',
                            en: 'Sugar syrup',
                            de: ''
                        },
                    },
                    sciroppo_dosaggio: {
                        label: {
                            it: 'Sciroppo di dosaggio',
                            en: 'Dosage syrup',
                            de: 'Zuckersirup'
                        },
                    },
                    imbottigliato_atmosfera_protettiva: {
                        label: {
                            it: 'Imbottigliato in atmosfera protettiva',
                            en: 'Bottled in a protective atmosphere dosage',
                            de: 'Unter Schutzatmosphäre abgefüllt'
                        },
                    },
                    additivi: {
                        label: {
                            it: 'Additivi',
                            en: 'Additives',
                            de: 'Additive'
                        },
                    },
                    anidride: {
                        label: {
                            it: "anidride solforosa",
                            en: "sulfur dioxide",
                            de: 'Schwefeldioxid'
                        }
                    },
                    bisolfito: {
                        label: {
                            it: "bisolfito di potassio",
                            en: "potassium bisulfite",
                            de: 'Kaliumbisulfit'
                        }
                    },
                    metabisolfito: {
                        label: {
                            it: "metabisolfito di potassio",
                            en: "potassium metabisulfite",
                            de: 'Kaliummetabisulfit'
                        }
                    },
                    sorbato: {
                        label: {
                            it: "sorbato di potassio",
                            en: "potassium sorbate",
                            de: ''
                        }
                    },
                    'l-ascorbico': {
                        label: {
                            it: "acido L-ascorbico",
                            en: "L-ascorbic acid",
                            de: 'Kaliumsorbat'
                        }
                    },
                    dmdc: {
                        label: {
                            it: "Dimetilcarbonato (DMDC)",
                            en: "Dimethyl carbonate (DMDC)",
                            de: 'Dimethylcarbonat (DMDC)'
                        }
                    },
                    resina: {
                        label: {
                            it: "resina di pino di Aleppo",
                            en: "Aleppo pine resin",
                            de: 'Aleppokiefernharz'
                        }
                    },
                    caramello: {
                        label: {
                            it: "Caramello",
                            en: "Caramel",
                            de: 'Karamell'
                        }
                    },
                    coadiuvanti: {
                        label: {
                            it: "Coadiuvanti tecnologici",
                            en: "Technological aids",
                            de: 'Technologische Hilfsmittel'
                        }
                    },
                    solfiti: {
                         label: {
                            it: "solfiti o anidride solforosa",
                            en: "sulphites or sulfur dioxide",
                            de: 'Sulfite oder Schwefeldioxid'
                        }
                    },
                    uovo: {
                         label: {
                            it: "uovo",
                            en: "egg",
                            de: 'Ei'
                        }
                    },
                    proteina: {
                         label: {
                            it: "proteina dell’uovo",
                            en: "egg protein",
                            de: 'Eiprotein'
                        }
                    },
                    'derivati-uovo': {
                         label: {
                            it: "derivati dell’uovo",
                            en: "egg derivatives",
                            de: 'Ei-Derivate'
                        }
                    },
                    ovoalbumina: {
                         label: {
                            it: "lisozima da uovo o ovoalbumina",
                            en: "lysozyme from egg or egg albumin",
                            de: 'Ei-Lysozym oder Ovalbumin'
                        }
                    },
                    latte: {
                         label: {
                            it: "latte",
                            en: "milk",
                            de: 'Milch'
                        }
                    },
                    'derivati-latte': {
                         label: {
                            it: "derivati del latte",
                            en: "milk derivatives",
                            de: 'Milchderivate'
                        }
                    },
                    'caseina-latte': {
                         label: {
                            it: "caseina del latte o proteina del latte",
                            en: "milk casein or milk protein",
                            de: 'Milchkasein oder Milchprotein'
                        }
                    },
                    regolatori_acidita: {
                        label: {
                            it: "Regolatori dell’acidità e agenti stabilizzanti",
                            en: "Acidity regulators and stabilizing agents",
                            de: 'Säureregulatoren und Stabilisierungsmittel'
                        }
                    },
                    "tartarico": {
                        label: {
                            it: "acido tartarico",
                            en: "tartaric acid",
                            de: "Weinsäure"
                        }
                    },
                    "malico": {
                        label: {
                            it: "acido malico",
                            en: "malic acid",
                            de: "Äpfelsäure"
                        }
                    },
                    "lattico": {
                        label: {
                            it: "acido lattico",
                            en: "lactic acid",
                            de: "Milchsäure"
                        }
                    },
                    "solfato-calcio": {
                        label: {
                            it: "solfato di calcio",
                            en: "calcium sulfate",
                            de: "Calciumsulfat"
                        }
                    },
                    "citrico": {
                        label: {
                            it: "acido citrico",
                            en: "citric acid",
                            de: "Zitronensäure"
                        }
                    },
                    "metatartarico": {
                        label: {
                            it: "acido metatartarico",
                            en: "metatartaric acid",
                            de: "Metaweinsäure"
                        }
                    },
                    "gomma-arabica": {
                        label: {
                            it: "gomma arabica",
                            en: "gum arabic",
                            de: "Arabischer gummi"
                        }
                    },
                    "lieviti": {
                        label: {
                            it: "mannoproteine di lieviti",
                            en: "yeast mannoproteins",
                            de: "Hefe-Mannoproteine"
                        }
                    },
                    "carbossimetilcellulosa": {
                        label: {
                            it: "Carbossimetilcellulosa",
                            en: "carboxymethylcellulose",
                            de: "Carboxymethylcellulose"
                        }
                    },
                    "poliaspartato": {
                        label: {
                            it: "Poliaspartato di potassio",
                            en: "potassium polyaspartate",
                            de: "Kaliumpolyaspartat"
                        }
                    },
                    "fumarico": {
                        label: {
                            it: "Acido fumarico",
                            en: "fumaric acid",
                            de: "Fumarsäure"
                        }
                    }
                }

            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            makeList(el) {
                let list = '';
                el.forEach(subel => {
                    list += subel.label[this.lang] + ', '
                })
                return list.substring(0, list.length-2)
            },
            translateUrl(lang) {
                if(lang == 'en') {
                    return window.location.href.replace('/it/', '/en/').replace('/vini/', '/wines/')
                }else{
                    return window.location.href.replace('/en/', '/it/').replace('/wines/', '/vini/')
                }
            }
        },
        computed: {
            productName() {
                return this.product['name'].replace('<br>', ' ')
            },
            nutritionalInformations() {
                if (this.combinationId) {
                    for (const combination of this.product.combinations) {
                        if (combination.code == this.combinationId && combination.nutritional_informations !== undefined) {
                            return combination.nutritional_informations;
                        }
                    }
                }
                return this.product.nutritional_informations;
            }
        }
    }

</script>

<style>

    @media (min-width:1800px) {

        .recycle-block .h1-like-text{
            font-size: 4.7rem
        }
    }

    @media (max-width:1440px) {
        .recycle-block .h1-like-text{
            font-size: 4.3rem
        }
    }

    @media (max-width:1199px) {
        .recycle-block .h1-like-text{
            font-size: 4rem
        }
    }

    @media (max-width:991px) {
        .recycle-block .h1-like-text{
            font-size: 3.4rem
        }
    }

    @media (max-width:575px) {
        .recycle-block .h1-like-text{
            font-size: 2.7rem
        }
    }

    @media (max-width:430px) {
        .recycle-block .h1-like-text{
            font-size: 2.4rem
        }
    }

    .recycle-block p{
        max-width:70ch;
        padding-left:15px;
        padding-right: 15px;
    }

    .shop-single-item__content.recycle{
        max-width: 100%;
    }

    th span, td span, .table-mobile *{font-family: "europa", sans-serif;}

    .bg-gold{
        background-color:#dfa877;
    }

    .bg-lightgold{
        background-color: #f2efea
    }

    .h6{
        margin-bottom: 0px;
    }

    .table td, .table th{
        border: 0px;
        vertical-align: middle;
    }

    .table-striped tbody tr:nth-of-type(odd) {
        background-color: #ffffff;
    }

    .table-striped tbody tr:nth-of-type(even) {
        background-color: #f2efea;
    }

    .shop-like-header__gold-text:after{
        display:none;
    }
    .shop-like-header__gold-text{
        border: 0px !important;
        padding: 0px;
    }

    @media (max-width: 767px){
        .gold-like-title {
            font-size: 1.2rem;
        }
    }

    .content-td{
        max-width: 65%;
    }

    .table-mobile{
        width: calc(100% - 30px);
        max-width: 400px;
    }

    @media (max-width: 420px) {
        .table-mobile{
            max-width: 420px;
        }
    }

</style>
